import CampaignService from '@forwardflow/services/CampaignService'
import { ICampaignUSP } from '@forwardflow/types/organization'
import { Button, TextAreaField, TextField } from '@forwardflow/ui'
import Form from 'antd/es/form'
import { useEffect, useState } from 'react'

interface IUSPSubmitForm {
   leadSource: string
   data: ICampaignUSP[]
   onSubmit: () => void
   selectedUSP?: ICampaignUSP
   setSelectedUSP: (usp: ICampaignUSP | undefined) => void
}

export const USPSubmitForm: React.FC<IUSPSubmitForm> = ({
   leadSource,
   data: uspData,
   selectedUSP,
   onSubmit,
   setSelectedUSP,
}) => {
   const [uspCharCount, setUspCharCount] = useState(0)
   const [detailsCharCount, setDetailsCharCount] = useState(0)
   const [isLoading, setLoading] = useState<boolean>(false)
   const [form] = Form.useForm()

   useEffect(() => {
      if (selectedUSP) {
         form.setFieldsValue(selectedUSP)
         setUspCharCount(selectedUSP.title.length)
         setDetailsCharCount(selectedUSP.description.length)
      }
   }, [selectedUSP, form])

   const handleSubmit = async () => {
      setLoading(true)
      const values = await form.validateFields()

      if (values) {
         let updatedData
         if (selectedUSP) {
            // Update the selected item while keeping all others
            updatedData = uspData.map((usp) =>
               usp.title === selectedUSP.title ? values : usp
            )
            // Clear the selectedUSP after successful edit
         } else {
            // Add new item to existing list
            updatedData = [...uspData, values]
         }

         await CampaignService.updateCampaignUsp(leadSource, updatedData)
         onSubmit()
         setSelectedUSP(undefined)
         form.resetFields()
         setUspCharCount(0)
         setDetailsCharCount(0)
         setLoading(false)
      }
   }

   return (
      <div>
         <p className="text-white/70 text-[12px] font-medium mb-3 px-10 mt-3">
            {selectedUSP ? 'Edit' : 'Add'} Unique Selling Point
         </p>
         <div className="relative bg-black/40">
            <Form
               layout="vertical"
               form={form}
               initialValues={{}}
               onFinish={handleSubmit}
               className="w-full text-left text-white"
               autoComplete="off"
            >
               <div className="px-10 border-b border-white/10 flexc">
                  <TextField
                     name="title"
                     formItemClassName="w-full"
                     placeholder="USP"
                     className="!border-none !bg-transparent !shadow-none relative top-3 !pl-0"
                     isRequired
                     maxLength={60}
                     errorMessage="Please enter USP"
                     onChange={(e) => setUspCharCount(e.target.value.length)}
                  />

                  <p className="text-[#B98BE6] whitespace-nowrap">
                     {uspCharCount}/60 char
                  </p>
               </div>
               <div className="px-10">
                  <TextAreaField
                     name="description"
                     placeholder="Type a sentence or two describing the USP"
                     formItemClassName="w-full"
                     className="!border-none !bg-transparent !h-20 !shadow-none relative top-3 !pl-0"
                     isRequired
                     maxLength={200}
                     errorMessage="Please enter USP detail"
                     onChange={(e) =>
                        setDetailsCharCount(e.target.value.length)
                     }
                  />
               </div>

               <div className="flex items-center justify-between p-3 pl-10">
                  <p className="text-[#B98BE6]">{detailsCharCount}/200 char</p>
                  <Button
                     isLoading={isLoading}
                     type="submit"
                     className="!h-10 !mt-0 max-w-[160px] !rounded !bg-primary/50 !border-none hover:!bg-primary/80"
                  >
                     {selectedUSP ? 'Edit' : 'Add'} USP
                  </Button>
               </div>
            </Form>
         </div>
      </div>
   )
}
